import React from 'react';

const MarketPanelEuropean = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">European Market</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="european-market">
            <thead>
              <tr>
                <th>Index Name</th>
                <th>High</th>
                <th>Prev. Close</th>
                <th>New 52 Week Low</th>
                <th>Chg%</th>
                <th>Technical Rating</th>
                <th>52 W High</th>
                <th>LTP</th>
                <th>Change (%)</th>
                <th>Open</th>
                <th>Open Percentage</th>
                <th>Low</th>
                <th>YTD (%)</th>
                <th>Outlook</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.index_name}</td>
                    <td>{item.index_data?.High || '-'}</td>
                    <td>{item.index_data?.['Prev. Close'] || '-'}</td>
                    <td>{item.index_data?.['52 W Low'] || '-'}</td>
                    <td>{item.index_data?.['Chg%'] || '-'}</td>
                    <td>{item.index_data?.['Technical Rating'] || '-'}</td>
                    <td>{item.index_data?.['52 W High'] || '-'}</td>
                    <td>{item.index_data?.LTP || '-'}</td>
                    <td>{item.index_data?.Change || '-'}</td>
                    <td>{item.index_data?.Open || '-'}</td>
                    <td>{item.index_data?.open_percentage || '-'}</td>
                    <td>{item.index_data?.Low || '-'}</td>
                    <td>{item.index_data?.['YTD (%)'] || '-'}</td>
                    <td>{item.index_data?.outlook || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelEuropean; 